import { BaseMutations } from '@/store/base-mutations';
import { Organizations } from '@/modules/organizations/types';
import ModelAccreditationState from './state';

export default class ModelAccreditationMutations extends BaseMutations<ModelAccreditationState> {
  SET_MODEL_ACCREDITATION(model_accreditation: Organizations.ModelAccreditation[]) {
    this.state.model_accreditation = model_accreditation;
  }

  SET_ACCREDITED_COUNT(accredited_count: number) {
    this.state.accredited_count = accredited_count;
  }

  TOGGLE_LOADING_MODEL_ACCREDITATION(toggle: boolean) {
    this.state.model_accreditation_loading = toggle;
  }

  TOGGLE_ACCREDITATE_FILTER(toggle: boolean) {
    this.state.filters_accreditation.is_only_accredited = toggle;
  }
}
